import { showLoading } from "../../helperFunctions.js";
import { centerMap, zeigeAlleFlaechenAn } from "../../mapFunctions.js";
import { loadAllAreas } from "../../searchFunctions.js";
import { treeFinder, zuruecksetzenBaumberater } from "../../treeFinderv2.js";

// Interner State für den Baumberater-Klick-Listener
let baumberaterKartenClickListener = null;

// layerSwitcherEl wird nach initTreeClimateDBApp gesetzt (via setLayerSwitcherEl)
let layerSwitcherEl = null;

export function setLayerSwitcherEl(el) {
  layerSwitcherEl = el;
}

export function initMapEventHandler(map) {
  const baumberaterToggle = document.getElementById("baumberaterToggle");
  const baumberaterHTMLElement = document.getElementById("baumberater");
  const alleFlaechenButton = document.getElementById("alleFlaechenButton");
  const centerMapButton = document.getElementById("centerMapButton");

  // Baumberater: aktivieren / deaktivieren
  baumberaterToggle.addEventListener("click", function () {
    const isActive = baumberaterToggle.getAttribute("data-aktiv") === "true";

    if (layerSwitcherEl) {
      layerSwitcherEl.classList.toggle("shown");
    }

    if (isActive) {
      baumberaterToggle.setAttribute("data-aktiv", "false");
      baumberaterToggle.classList.remove("btn-danger");
      baumberaterToggle.classList.add("btn-success");
      baumberaterToggle.textContent = "Baumberater aktivieren";
      zuruecksetzenBaumberater();

      if (baumberaterKartenClickListener) {
        map.un("click", baumberaterKartenClickListener);
        baumberaterKartenClickListener = null;
        baumberaterHTMLElement.style.visibility = "hidden";
      }
    } else {
      baumberaterToggle.setAttribute("data-aktiv", "true");
      baumberaterToggle.classList.remove("btn-success");
      baumberaterToggle.classList.add("btn-danger");
      baumberaterToggle.textContent = "Baumberater deaktivieren";
      baumberaterHTMLElement.style.visibility = "visible";

      baumberaterKartenClickListener = function (evt) {
        treeFinder(evt.coordinate);
      };
      map.on("click", baumberaterKartenClickListener);
    }
  });

  // Alle Waldflächen anzeigen
  alleFlaechenButton.onclick = async function () {
    showLoading(true);
    const flaechen = await loadAllAreas();
    if (flaechen != null && flaechen.length > 0) {
      zeigeAlleFlaechenAn(flaechen, map);
    }
    showLoading(false);
  };

  // Karte zentrieren
  centerMapButton.onclick = function () {
    centerMap(49.4039607, 6.9045054, 10);
  };
}
